import * as React from "react"
import { ChevronLeft, ChevronRight, MoreHorizontal } from "lucide-react"

import { cn } from "../../lib/utils"
import { buttonVariants } from "./button"

function Pagination({ className, ...props }) {
  return (
    <nav
      role="navigation"
      aria-label="pagination"
      className={cn("mx-auto flex w-full justify-center", className)}
      {...props}
    />
  )
}

function PaginationContent({ className, ...props }) {
  return <ul className={cn("flex flex-row items-center gap-1", className)} {...props} />
}

function PaginationItem({ ...props }) {
  return <li {...props} />
}

function PaginationLink({ className, isActive, size = "icon", ...props }) {
  return (
    <a
      aria-current={isActive ? "page" : undefined}
      className={cn(
        buttonVariants({
          variant: isActive ? "outline" : "ghost",
          size,
        }),
        className
      )}
      {...props}
    />
  )
}

function PaginationPrevious({
  className,
  label = "Previous",
  ariaLabel = "Go to previous page",
  ...props
}) {
  return (
    <PaginationLink aria-label={ariaLabel} size="default" className={cn("gap-1 px-2.5 sm:px-4", className)} {...props}>
      <ChevronLeft className="h-4 w-4" />
      <span className="hidden sm:inline">{label}</span>
    </PaginationLink>
  )
}

function PaginationNext({
  className,
  label = "Next",
  ariaLabel = "Go to next page",
  ...props
}) {
  return (
    <PaginationLink aria-label={ariaLabel} size="default" className={cn("gap-1 px-2.5 sm:px-4", className)} {...props}>
      <span className="hidden sm:inline">{label}</span>
      <ChevronRight className="h-4 w-4" />
    </PaginationLink>
  )
}

function PaginationEllipsis({
  className,
  srLabel = "More pages",
  ...props
}) {
  return (
    <span aria-hidden className={cn("flex h-9 w-9 items-center justify-center", className)} {...props}>
      <MoreHorizontal className="h-4 w-4" />
      <span className="sr-only">{srLabel}</span>
    </span>
  )
}

export {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
}
